import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => {
  return (
    <>
      <g clipPath="url(#clip0_2557_163862)">
        <path
          d="M13.4086 11.9981L18.7045 6.71239C18.8926 6.52427 18.9983 6.26913 18.9983 6.00309C18.9983 5.73706 18.8926 5.48192 18.7045 5.2938C18.5164 5.10568 18.2612 5 17.9952 5C17.7291 5 17.474 5.10568 17.2859 5.2938L12 10.5895L6.71414 5.2938C6.52602 5.10568 6.27087 5 6.00483 5C5.73878 5 5.48363 5.10568 5.29551 5.2938C5.10739 5.48192 5.0017 5.73706 5.0017 6.00309C5.0017 6.26913 5.10739 6.52427 5.29551 6.71239L10.5914 11.9981L5.29551 17.2838C5.20187 17.3767 5.12755 17.4872 5.07683 17.6089C5.02611 17.7306 5 17.8612 5 17.9931C5 18.125 5.02611 18.2556 5.07683 18.3773C5.12755 18.499 5.20187 18.6095 5.29551 18.7024C5.38839 18.796 5.49888 18.8703 5.62062 18.9211C5.74236 18.9718 5.87294 18.9979 6.00483 18.9979C6.13671 18.9979 6.26729 18.9718 6.38903 18.9211C6.51077 18.8703 6.62127 18.796 6.71414 18.7024L12 13.4067L17.2859 18.7024C17.3787 18.796 17.4892 18.8703 17.611 18.9211C17.7327 18.9718 17.8633 18.9979 17.9952 18.9979C18.1271 18.9979 18.2576 18.9718 18.3794 18.9211C18.5011 18.8703 18.6116 18.796 18.7045 18.7024C18.7981 18.6095 18.8724 18.499 18.9232 18.3773C18.9739 18.2556 19 18.125 19 17.9931C19 17.8612 18.9739 17.7306 18.9232 17.6089C18.8724 17.4872 18.7981 17.3767 18.7045 17.2838L13.4086 11.9981Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2557_163862">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </>
  );
};

export default Icon;
